import React from 'react'
import StepButton from '@mui/material/StepButton';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import MakingDonations from './makingDonation';
import TransactionProof from './transactionProof';
import { Divider } from '@mui/material';
import DigitalCert from './digitalCert';

export default function Donate() {

  const steps = ["Make a Donation", "Proof of Donation", "Redeem Digital Certificate"];
  const [activeStep, setActiveStep] = React.useState(0);

  const totalSteps = () => {
    return steps.length;
  }

  const handleStep = (step) => {
    setActiveStep(step);
  }

  const getLayout = (activePage) => {
    switch (activePage) {
      case 0:
        return <MakingDonations currentActive={activeStep} maxStep={totalSteps()} setNextStep={handleStep} />;
      case 1:
        return <TransactionProof currentActive={activeStep} maxStep={totalSteps()} setNextStep={handleStep} />;
      case 2:
        return <DigitalCert currentActive={activeStep} maxStep={totalSteps()} setNextStep={handleStep} />;
      default:
        return null;
    }
  }

  return (
    <div className='w-75 mx-auto' id="donation">
      <Divider />
      <h2 className="text-center mt-3">❤️Donations</h2>
      <Stepper nonLinear activeStep={activeStep} orientation="horizontal" className='donate-mobile'>
        {
          steps.map((label, index) => {
            return (
              <Step key={label}>
                <StepButton onClick={() => handleStep(index)}>
                  {label}
                </StepButton>
              </Step>
            );
          })
        }
      </Stepper>
      <Stepper nonLinear activeStep={activeStep} orientation="vertical" className='donate-desktop'>
        {
          steps.map((label, index) => {
            return (
              <Step key={label}>
                <StepButton onClick={() => handleStep(index)}>
                  {label}
                </StepButton>
              </Step>
            );
          })
        }
      </Stepper>
      <div>
        {getLayout(activeStep)}
      </div>
    </div>
  )
}
